const axios = require("axios");

export const getToken = () => {
  if (localStorage.getItem("keptLogged") == "true") {
    return localStorage.getItem("token") || null;
  }
  return sessionStorage.getItem("token") || null;
};

export const get_workflow_data = async (id) => {
  const response = await axios.get(
    process.env.REACT_APP_API_BASE_URL + `workflows/${id}`,
    {
      headers: {
        Authorization: "Bearer " + getToken(),
      },
    }
  );
  return response.data;
};

export const post_step = async (
  workflow_id,
  metadata_id,
  sources,
  target,
  variables,
  conditions,
  path,
  stp
) => {
  var filteredsteps = [];
  if (stp.length > 0) {
    stp.forEach((step) => {

      var step_obj = {};
      step_obj.variables = step.variables;
      step_obj.id = step.id;
      step_obj.conditions = step.conditions;
      step_obj.sources = step.sources;
      step_obj.targetA = step.targetA;
      step_obj.targetB = step.targetB;
      step_obj.workflowId = step.workflowId;
      step_obj.metadataId = step.metadata.id;
      step_obj.info = step.info;
      filteredsteps.push(step_obj);
    });
  }

  const result = await axios({
    method: "post",
    url: process.env.REACT_APP_API_BASE_URL + `workflows/${workflow_id}/steps`,
    headers: {
      Authorization: "Bearer " + getToken(),
    },
    data: {
      workflow: {
        id: workflow_id,
        steps: filteredsteps,
      },
      newStep: {
        metadataId: metadata_id,
        sources: sources,
        pathType: path,
        target: target,
        variables: variables,
        conditions: conditions,
      },
    },
  });

  return result.data;
};

export const edit_step = async (workflow_id, stp) => {
  var filteredsteps = [];
  if (stp.length > 0) {
    stp.forEach((step) => {

      var step_obj = {};
      step_obj.variables = step.variables;
      step_obj.id = step.id;
      step_obj.conditions = step.conditions;
      step_obj.sources = step.sources;
      step_obj.targetA = step.targetA;
      step_obj.targetB = step.targetB;
      step_obj.workflowId = step.workflowId;
      step_obj.metadataId = step.metadata.id;
      step_obj.info = step.info;
      filteredsteps.push(step_obj);
    });
  }

  const result = await axios({
    method: "post",
    url: process.env.REACT_APP_API_BASE_URL + `workflows/${workflow_id}/steps`,
    headers: {
      Authorization: "Bearer " + getToken(),
    },
    data: {
      workflow: {
        id: workflow_id,
        steps: filteredsteps,
      },
    },
  });

  return result.data;
};

export const delete_step = async (wf_id, st_id) => {
  const result = await axios.delete(
    process.env.REACT_APP_API_BASE_URL + `workflows/${wf_id}/steps/${st_id}`,
    {
      headers: {
        Authorization: "Bearer " + getToken(),
      },
    }
  );
  return result.data;
};
export const createWorkflow = async (
  name,
  description,
  isReRun,
  templateId
) => {
  const result = await axios({
    method: "post",
    url: process.env.REACT_APP_API_BASE_URL + `workflows`,
    headers: {
      Authorization: "Bearer " + getToken(),
    },
    data: {
      name: name,
      description: description,
      rerunOnTrigger: isReRun,
      templateId: templateId,
    },
  });
  // catch api error

  return result;
};

export const get_metadata_info = async (id) => {
  const response = await axios.get(
    process.env.REACT_APP_API_BASE_URL + `workflows/metadata/${id}`,
    {
      headers: {
        Authorization: "Bearer " + getToken(),
      },
    }
  );
  return response.data;
};

export const get_step_data = async (wf_id, step_id) => {
  const response = await axios.get(
    process.env.REACT_APP_API_BASE_URL + `workflows/${wf_id}/steps/${step_id}`,
    {
      headers: {
        Authorization: "Bearer " + getToken(),
      },
    }
  );
  return response.data;
};

export const getfilterValuesDropDown = async (url) => {
  const response = await axios.get(
    process.env.REACT_APP_API_BASE_URL + `${url}`,
    {
      headers: {
        Authorization: "Bearer " + getToken(),
      },
    }
  );
  return response.data;
};

export const custom_api_call = async (url) => {
  const response = await axios.get(
    process.env.REACT_APP_API_BASE_URL + `${url}`,
    {
      headers: {
        Authorization: "Bearer " + getToken(),
      },
    }
  );
  return response.data;
};

export const getworkflowmetadata = async (param) => {
  var parameter = param == "StartEvent" ? "?type=StartEvent" : "";
  const response = await axios.get(
    process.env.REACT_APP_API_BASE_URL + "workflows/metadata" + parameter,
    {
      headers: {
        Authorization: "Bearer " + getToken(),
      },
    }
  );
  return response.data;
};

export const getnewfilterdata = async () => {
  const response = await axios.get(
    process.env.REACT_APP_API_BASE_URL + "personal/filters/new",
    {
      headers: {
        Authorization: "Bearer " + getToken(),
      },
    }
  );
  return response.data;
};
